export const langs = [
    'en',
    'de',
    'ro',
    'es',
    'fr',
    'pt',
    'it',
    'el',
    'sl',
] as const
export type TLang = (typeof langs)[number]

export const normalizeBrowserLang = (lang: string): TLang => {
    const base = (lang ?? 'en').split('-')[0].toLowerCase()
    return langs.includes(base as TLang) ? (base as TLang) : 'en'
}
